<script>
	import { api } from "./../libs/api.js";
	import { _ } from 'svelte-i18n';

	import { Link } from 'svelte-routing';

	import BaseLayer from "./../components/BaseLayer.svelte";

	export let id;

	let trail = api.get_trail(id);

	let difficulty_levels = {
		0: 'trails.beginner',
		1: 'trails.easy',
		2: 'trails.moderate',
		3: 'trails.advanced'
	}
</script>

<BaseLayer --bg-overlay="url(/assets/bg/mountains.svg)">
	{#await trail then value}
		<div class="hero aspect-square bg-cover rounded-br-3xl rounded-bl-3xl overflow-hidden drop-shadow-lg"
			style="background-image: url({api.base_url}/assets/{value.data.cover_image});">
		</div>

		<div class="text-center mt-2">
			<Link class="btn btn-accent w-72 font-bold text-md mt-3 rounded-3xl" to="navigate/{id}">{$_('trails.start')}</Link>
			<a class="btn btn-accent btn-outline w-72 font-bold text-md mt-3 rounded-3xl" href="https://www.google.com/maps/dir/?api=1&destination={value.data.track.coordinates[0][1]},{value.data.track.coordinates[0][0]}">{$_('trails.bring_me')}</a>
		</div>

		<div class="px-4 pb-20">
			<div class="-mx-4 py-4">
				<h2 class="page-title text-center pt-4 py-8">{value.data.translations[0].name}</h2>

				<div class="px-4 mb-6">
					<div class="flex justify-between bg-gray-100 -mx-4 px-14 mb-2 py-2">
						<span>{$_('trails.length')}</span>
						<span class="text-right font-bold">{value.data.length} {$_('trails.km')}</span>
					</div>

					<div class="flex justify-between bg-gray-100 -mx-4 px-14 mb-2 py-2">
						<span>{$_('trails.duration')}</span>
						<span class="text-right font-bold">{value.data.duration} {$_('trails.minutes')}</span>
					</div>

					<div class="flex justify-between bg-gray-100 -mx-4 px-14 mb-2 py-2">
						<span>{$_('trails.level')}</span>
						<span class="text-right font-bold">{$_(difficulty_levels[value.data.difficulty])}</span>
					</div>
				</div>
			</div>

			<h3 class="page-title mt-6">{$_('trails.additional_info')}</h3>
			<p class="rich-content">{@html value.data.translations[0].description}</p>
		</div>
	{/await}
</BaseLayer>

